import axios from "axios";
const API_URL = process.env.REACT_APP_API_URL;

export const getProveedores = async () => {
  const token = localStorage.getItem("token");
  const response = await axios.get(`${API_URL}/api/proveedores`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};

export const getProveedoresConTipo = async () => {
  const token = localStorage.getItem("token");
  const response = await axios.get(`${API_URL}/api/proveedores-con-tipo`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};

export const getForwarderProveedores = async () => {
  const proveedores = await getProveedoresConTipo();
  return (Array.isArray(proveedores) ? proveedores : [])
    .filter((row) => {
      const tipoId = Number(
        row?.ProveedorTipo ?? row?.tipoProveedor?.id_ProveedorTipo,
      );
      return tipoId === 6;
    })
    .map((row) => String(row?.N_PROVEEDOR ?? "").trim())
    .filter(Boolean)
    .filter((value, index, arr) => arr.indexOf(value) === index)
    .sort((a, b) => a.localeCompare(b, undefined, { sensitivity: "base" }));
};

/* para el Drawer de la Ficha de Proveedores */
export const getProveedorTipos = async () => {
  const token = localStorage.getItem("token");
  const response = await axios.get(`${API_URL}/api/proveedorTipo`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};

export const updateProveedor = async (proveedor) => {
  const token = localStorage.getItem("token");

  const response = await axios.put(
    `${API_URL}/api/proveedores/${proveedor.CODPROV}`,
    proveedor,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    }
  );

  return response.data;
};

/* Provvedores Contactos */
export const getContactosProveedor = async (CODPROV) => {
  const token = localStorage.getItem("token");
  const response = await axios.get(
    `${API_URL}/api/proveedores/${CODPROV}/contactos`,
    {
      headers: { Authorization: `Bearer ${token}` },
    }
  );
  return response.data;
};

export const addContactoProveedor = async (CODPROV, contacto) => {
  const token = localStorage.getItem("token");
  const response = await axios.post(
    `${API_URL}/api/proveedores/${CODPROV}/contactos`,
    contacto,
    {
      headers: { Authorization: `Bearer ${token}` },
    }
  );
  return response.data;
};

export const updateContactoProveedor = async (id, contacto) => {
  const token = localStorage.getItem("token");
  const response = await axios.put(`${API_URL}/api/contactos/${id}`, contacto, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data;
};

export const deleteContactoProveedor = async (id) => {
  const token = localStorage.getItem("token");
  const response = await axios.delete(`${API_URL}/api/contactos/${id}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data;
};

// Añadir nuevo proveedor
export const createProveedor = async (proveedor) => {
  const token = localStorage.getItem("token");
  const response = await axios.post(`${API_URL}/api/proveedores`, proveedor, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
  return response.data;
};

/** Sin filas en ProveedorFabricas; aptos para traspaso al catálogo de fábricas. */
export const getProveedoresElegiblesTraspasoFabrica = async () => {
  const token = localStorage.getItem("token");
  const response = await axios.get(
    `${API_URL}/api/proveedores-elegibles-traspaso-fabrica`,
    { headers: { Authorization: `Bearer ${token}` } }
  );
  return response.data;
};

/**
 * @param {number} CODPROV
 * @param {{ id_FabricaTipo?: number|null, keepAsTrader: boolean }} body
 */
export const traspasoProveedorAFabrica = async (CODPROV, body) => {
  const token = localStorage.getItem("token");
  const response = await axios.post(
    `${API_URL}/api/proveedores/${CODPROV}/traspaso-a-fabrica`,
    body,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    }
  );
  return response.data;
};
